import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { MicroFrontendResolver } from 'core/resolvers';
import { CustomizationListComponent } from './components/customization-list/customization-list.component';
import { CustomizationDetailComponent } from './components/customization-detail/customization-detail.component';
import { RoleplaySubscriptionListComponent } from './components/roleplay-subscription-list/roleplay-subscription-list.component';

const roleplayRoutes: Routes = [
  {
    path: 'roleplays',
    title: 'parentRoleplays',
    data: { microfrontends: ['GlRoleplay'] },
    resolve: {
      glRoleplay: MicroFrontendResolver
    },
    children: [
      {
        path: '',
        title: 'roleplayCustomizations',
        component: CustomizationListComponent,
        canActivate: [ProfileGuard],
        data: { action: 'roleplay.list' }
      },
      {
        path: ':customizationId',
        title: 'roleplayCustomizationDetail',
        component: CustomizationDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'roleplay.detail' }
      }
    ]
  },
  {
    path: 'roleplay-subscriptions',
    title: 'roleplaySubscriptions',
    component: RoleplaySubscriptionListComponent,
    canActivate: [ProfileGuard],
    data: { action: 'roleplay.subscription.list', microfrontends: ['GlRoleplay'] },
    resolve: {
      glRoleplay: MicroFrontendResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(roleplayRoutes)],
  exports: [RouterModule]
})
export class RoleplayRoutingModule {}
